/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointMapLocation } from './DataPointMapLocation';
import {
    DataPointMapLocationFromJSON,
    DataPointMapLocationFromJSONTyped,
    DataPointMapLocationToJSON,
    DataPointMapLocationToJSONTyped,
} from './DataPointMapLocation';

/**
 * Custom serializer that returns map data.
 * @export
 * @interface DataPointMap
 */
export interface DataPointMap {
    /**
     * 
     * @type {string}
     * @memberof DataPointMap
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof DataPointMap
     */
    detectedRate: number;
    /**
     * 
     * @type {number}
     * @memberof DataPointMap
     */
    concentration: number;
    /**
     * 
     * @type {string}
     * @memberof DataPointMap
     */
    plumeImage: string;
    /**
     * 
     * @type {DataPointMapLocation}
     * @memberof DataPointMap
     */
    location: DataPointMapLocation;
    /**
     * 
     * @type {Date}
     * @memberof DataPointMap
     */
    detectionTimestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof DataPointMap
     */
    providerId: string;
}

/**
 * Check if a given object implements the DataPointMap interface.
 */
export function instanceOfDataPointMap(value: object): value is DataPointMap {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('detectedRate' in (value as Record<string, any>)) && !('detected_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectedRate'] === undefined && (value as Record<string, any>)['detected_rate'] === undefined)) return false;
    if (!('concentration' in value) || value['concentration'] === undefined) return false;
    if ((!('plumeImage' in (value as Record<string, any>)) && !('plume_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['plumeImage'] === undefined && (value as Record<string, any>)['plume_image'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectionTimestamp' in (value as Record<string, any>)) && !('detection_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionTimestamp'] === undefined && (value as Record<string, any>)['detection_timestamp'] === undefined)) return false;
    if ((!('providerId' in (value as Record<string, any>)) && !('provider_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['providerId'] === undefined && (value as Record<string, any>)['provider_id'] === undefined)) return false;
    return true;
}

export function DataPointMapFromJSON(json: any): DataPointMap {
    return DataPointMapFromJSONTyped(json, false);
}

export function DataPointMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointMap {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'detectedRate': json['detected_rate'],
        'concentration': json['concentration'],
        'plumeImage': json['plume_image'],
        'location': DataPointMapLocationFromJSON(json['location']),
        'detectionTimestamp': (new Date(json['detection_timestamp'])),
        'providerId': json['provider_id'],
    };
}

export function DataPointMapToJSON(json: any): DataPointMap {
    return DataPointMapToJSONTyped(json, false);
}

export function DataPointMapToJSONTyped(value?: DataPointMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'detected_rate': value['detectedRate'],
        'concentration': value['concentration'],
        'plume_image': value['plumeImage'],
        'location': DataPointMapLocationToJSON(value['location']),
        'detection_timestamp': value['detectionTimestamp'].toISOString(),
        'provider_id': value['providerId'],
    };
}

